import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import {
    STATUS_OPTIONS,
    statusLabel,
    statusBadge,
    statusIcon,
    currencyLabel,
    saleNumber,
} from "./orderStatus";
import "../shared/rtl-panel.css";

const formatDate = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    if (isNaN(date.getTime())) return "—";
    return date.toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
};

// Converted quantities can land on a fraction (darzan ÷ darzan-per-carton);
// keep up to 2 decimals and drop trailing zeros so whole numbers stay clean.
const trimNum = (value) => {
    if (!isFinite(value)) return "";
    return Number(Math.round(value * 100) / 100);
};

const Money = ({ value }) => (
    <NumberFormat value={value} displayType="text" thousandSeparator={true} />
);

class ModelOrders extends Component {
    render() {
        return (
            <ProductConsumer>
                {(value) => {
                    const {
                        OR_modalOpen,
                        OR_selectedOrder,
                        OR_CloseModal,
                        OR_newStatus,
                        OR_staffNote,
                        OR_saving,
                        OR_updateStatus,
                        OR_saveAsInvoice,
                        OR_froshtn,
                        OR_whossale,
                        OR_joripara,
                        OR_numberOfWakil,
                        OR_saleNote,
                        OR_saleInfo,
                        AddProChange,
                        OR_openSaleInvoice,
                    } = value;

                    if (!OR_modalOpen || !OR_selectedOrder) return null;

                    const order = OR_selectedOrder;
                    const customer = order.customer || {};
                    const items = Array.isArray(order.items) ? order.items : [];
                    const isUSD = (order.currency || "").toUpperCase() === "USD";

                    const confirming = OR_newStatus === "confirmed";
                    // An order with a saleRef is already invoiced; re-confirming is
                    // idempotent (no second invoice), so lock the button.
                    const alreadyInvoiced = !!order.saleRef || !!OR_saleInfo;
                    // Straight after accepting, the number comes from the PATCH
                    // response; on a later visit it rides along on the populated
                    // `saleRef`.
                    const invoiceNo =
                        (OR_saleInfo && OR_saleInfo.numberofwasl) || saleNumber(order.saleRef);
                    const hasDiscount = order.subtotal !== order.total;

                    return (
                        <div className="rs-modal" dir="rtl" onClick={OR_CloseModal}>
                            <div
                                className="rs-modal__panel"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className="rs-modal__head">
                                    <h5 className="rs-modal__title">
                                        <i className="fas fa-shopping-cart"></i>
                                        داواکاری <span className="rs-num">#{order.orderNumber}</span>
                                    </h5>
                                    <span className={`rs-badge ${statusBadge(order.status)}`}>
                                        <i className={`fas ${statusIcon(order.status)}`}></i>
                                        {statusLabel(order.status)}
                                    </span>

                                    <div className="rs-modal__actions">
                                        {!alreadyInvoiced ? (
                                            <button
                                                className="rs-btn rs-btn--green rs-btn--sm"
                                                onClick={OR_saveAsInvoice}
                                                disabled={OR_saving}
                                                title="پەسەندکردن و دروستکردنی پسوڵە ڕاستەوخۆ"
                                            >
                                                {OR_saving ? (
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-file-invoice-dollar"></i>
                                                        فرۆشتن و پسوڵە
                                                    </>
                                                )}
                                            </button>
                                        ) : null}
                                        <button
                                            className="rs-btn rs-btn--danger rs-btn--sm"
                                            onClick={OR_CloseModal}
                                        >
                                            <i className="fas fa-times"></i>
                                            داخستن
                                        </button>
                                    </div>
                                </div>

                                <div className="rs-modal__body">
                                    <div className="rs-meta">
                                        <div>
                                            <span className="rs-meta__k">کڕیار</span>
                                            <span className="rs-meta__v">{customer.name || "—"}</span>
                                        </div>
                                        <div>
                                            <span className="rs-meta__k">مۆبایل</span>
                                            <span className="rs-meta__v rs-num">
                                                {customer.phone || "—"}
                                            </span>
                                        </div>
                                        <div>
                                            <span className="rs-meta__k">بەرواری داواکاری</span>
                                            <span className="rs-meta__v rs-num">
                                                {formatDate(order.createdAt)}
                                            </span>
                                        </div>
                                        <div style={{ gridColumn: customer.note ? "auto" : "span 2" }}>
                                            <span className="rs-meta__k">ناونیشان</span>
                                            <span className="rs-meta__v">{customer.address || "—"}</span>
                                        </div>
                                        {customer.note ? (
                                            <div>
                                                <span className="rs-meta__k">تێبینی کڕیار</span>
                                                <span className="rs-meta__v">{customer.note}</span>
                                            </div>
                                        ) : null}
                                    </div>

                                    <h6 className="rs-section__title">
                                        <i className="fas fa-boxes"></i>
                                        کاڵاکان
                                        <span className="rs-section__aside rs-pager__count rs-num">
                                            {items.length} جۆر
                                        </span>
                                    </h6>

                                    <div className="RR">
                                        <table className="table table-striped table-bordered tc m-auto">
                                            <thead>
                                                <tr className="text-warning f4">
                                                    <th style={{ border: "2px solid #f0ad4e" }}>کۆد</th>
                                                    <th style={{ border: "2px solid #f0ad4e" }}>ناوی شتەکان</th>
                                                    <th style={{ border: "2px solid #f0ad4e" }}>کارتۆن</th>
                                                    <th style={{ border: "2px solid #f0ad4e" }}>دەرزەن</th>
                                                    <th style={{ border: "2px solid #f0ad4e" }}>نرخ</th>                                                                                      
                                                     <th style={{ border: "2px solid #f0ad4e" }}>
                                                        {isUSD ? "$ کۆی گشتی" : "ID کۆی گشتی"}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {items.map((item, i) => {
                                                    // The order stores one unit per line (carton | darzan |
                                                    // dana). Fill both columns by converting through
                                                    // numberOfDarzan (darzan per carton) so a carton line
                                                    // also shows its darzan count and vice versa.
                                                    const perCarton = Number(item.numberOfDarzan) || 0;
                                                    let cartonQty = "";
                                                    let darzanQty = "";
                                                    if (item.unit === "carton") {
                                                        cartonQty = item.quantity;
                                                        darzanQty = perCarton
                                                            ? trimNum(item.quantity * perCarton)
                                                            : "";
                                                    } else if (item.unit === "darzan") {
                                                        cartonQty = perCarton
                                                            ? trimNum(item.quantity / perCarton)
                                                            : "";
                                                        darzanQty = item.quantity;
                                                    }
                                                    return (
                                                        <tr
                                                            key={i}
                                                            className="f4"
                                                            style={{
                                                                color: i === 0 ? "white" : "black",
                                                                backgroundColor: i === 0 ? "#20B2AA" : "",
                                                            }}
                                                        >
                                                          
                                                            <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                                                                {item.code}
                                                            </td>
                                                            <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                                                                {item.name}
                                                            </td>
                                                            <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                                                                {cartonQty}
                                                            </td>
                                                            <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                                                                {darzanQty}
                                                            </td>
                                                            <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                                                                <Money value={item.unitPrice} />
                                                            </td>
                                                             <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                                                                <Money value={item.lineTotal} />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="rs-totals">
                                        {hasDiscount ? (
                                            <div className="rs-total">
                                                <span className="rs-total__k">کۆی بەشەکان</span>
                                                <span className="rs-total__v">
                                                    <span className="rs-num">
                                                        <Money value={order.subtotal} />
                                                    </span>{" "}
                                                    {currencyLabel(order.currency)}
                                                </span>
                                            </div>
                                        ) : null}
                                        <div className="rs-total rs-total--main">
                                            <span className="rs-total__k">کۆی گشتی</span>
                                            <span className="rs-total__v">
                                                <span className="rs-num">
                                                    <Money value={order.total} />
                                                </span>{" "}
                                                {currencyLabel(order.currency)}
                                            </span>
                                        </div>
                                    </div>

                                    {order.handledBy ? (
                                        <p className="rs-sub" style={{ marginTop: "10px" }}>
                                            دوایین گۆڕانکاری لەلایەن{" "}
                                            <span className="rs-mark">{order.handledBy.name}</span>{" "}
                                            — <span className="rs-num">{formatDate(order.handledAt)}</span>
                                        </p>
                                    ) : null}

                                    {alreadyInvoiced ? (
                                        <div className="rs-alert rs-alert--green">
                                            <i className="fas fa-check-circle"></i>
                                            {invoiceNo ? (
                                                <span>
                                                    پسوڵە دروستکراوە — ژمارەی وەسڵ:{" "}
                                                    {/* Two halves of one jump: the loader fills the
                                                        invoice screen's R_* state (and closes this
                                                        modal), the <Link> routes to it. */}
                                                    <span className="rs-wasl-link">
                                                        <Link
                                                            to="/rent"
                                                            title="کردنەوەی پسوڵە"
                                                            onClick={() =>
                                                                OR_openSaleInvoice(invoiceNo)
                                                            }
                                                        >
                                                            <strong className="rs-num">
                                                                {invoiceNo}
                                                            </strong>
                                                            <i className="fas fa-external-link-alt"></i>
                                                        </Link>
                                                    </span>
                                                </span>
                                            ) : (
                                                <span>ئەم داواکارییە پسوڵەی بۆ دروستکراوە.</span>
                                            )}
                                        </div>
                                    ) : null}

                                    <div className="rs-form">
                                        <div className="rs-field">
                                            <label className="rs-field__label" htmlFor="OR_newStatus">
                                                دۆخی نوێ
                                            </label>
                                            <select
                                                id="OR_newStatus"
                                                name="OR_newStatus"
                                                value={OR_newStatus}
                                                onChange={AddProChange}
                                                className="rs-select"
                                            >
                                                {STATUS_OPTIONS.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="rs-field" style={{ gridColumn: "span 2" }}>
                                            <label className="rs-field__label" htmlFor="OR_staffNote">
                                                تێبینی کارمەند
                                            </label>
                                            <input
                                                id="OR_staffNote"
                                                type="text"
                                                name="OR_staffNote"
                                                value={OR_staffNote}
                                                onChange={AddProChange}
                                                className="rs-input"
                                                placeholder="..."
                                            />
                                        </div>

                                        {/* Sale details — required by the API only when confirming */}
                                        {confirming ? (
                                            <>
                                                <div className="rs-form__rule">
                                                    <i className="fas fa-file-invoice"></i>
                                                    زانیاری پسوڵە
                                                </div>

                                                <div className="rs-field">
                                                    <label className="rs-field__label" htmlFor="OR_joripara">
                                                        جۆری دراو
                                                    </label>
                                                    <select
                                                        id="OR_joripara"
                                                        name="OR_joripara"
                                                        value={OR_joripara}
                                                        onChange={AddProChange}
                                                        className="rs-select"
                                                    >
                                                        <option>دۆلار</option>
                                                        <option>دینار</option>
                                                    </select>
                                                </div>

                                                <div className="rs-field">
                                                    <label className="rs-field__label" htmlFor="OR_froshtn">
                                                        جۆری فرۆشتن
                                                    </label>
                                                    <input
                                                        id="OR_froshtn"
                                                        type="text"
                                                        name="OR_froshtn"
                                                        value={OR_froshtn}
                                                        onChange={AddProChange}
                                                        className="rs-input"
                                                    />
                                                </div>

                                                <div className="rs-field">
                                                    <label className="rs-field__label" htmlFor="OR_whossale">
                                                        شوێنی فرۆشتن
                                                    </label>
                                                    <input
                                                        id="OR_whossale"
                                                        type="text"
                                                        name="OR_whossale"
                                                        value={OR_whossale}
                                                        onChange={AddProChange}
                                                        className="rs-input"
                                                    />
                                                </div>

                                                <div className="rs-field">
                                                    <label
                                                        className="rs-field__label"
                                                        htmlFor="OR_numberOfWakil"
                                                    >
                                                        کۆدی وەکیل (قەرز)
                                                    </label>
                                                    <input
                                                        id="OR_numberOfWakil"
                                                        type="text"
                                                        name="OR_numberOfWakil"
                                                        value={OR_numberOfWakil}
                                                        onChange={AddProChange}
                                                        className="rs-input"
                                                        placeholder="0 = کاش"
                                                    />
                                                </div>

                                                <div className="rs-field rs-form__full">
                                                    <label className="rs-field__label" htmlFor="OR_saleNote">
                                                        تێبینی پسوڵە
                                                    </label>
                                                    <input
                                                        id="OR_saleNote"
                                                        type="text"
                                                        name="OR_saleNote"
                                                        value={OR_saleNote}
                                                        onChange={AddProChange}
                                                        className="rs-input"
                                                        placeholder="داواکاری ئۆنڵاین #..."
                                                    />
                                                </div>
                                            </>
                                        ) : null}

                                        <div className="rs-form__full" style={{ textAlign: "left" }}>
                                            <button
                                                className="rs-btn rs-btn--primary"
                                                onClick={OR_updateStatus}
                                                disabled={OR_saving || (confirming && alreadyInvoiced)}
                                            >
                                                {OR_saving ? (
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                ) : confirming ? (
                                                    <>
                                                        <i className="fas fa-file-invoice"></i>
                                                        پەسەندکردن و پسوڵە
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-save"></i>
                                                        پاشەکەوت
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </ProductConsumer>
        );
    }
}

export default ModelOrders;
